import { Controller } from "@hotwired/stimulus"

// Drops the cursor into a field on render, so the common "land on an index page,
// start typing a search" flow needs no mouse. Wired into Ui::FilterFormComponent
// by default; usable on its own anywhere:
//
//   <form data-controller="autofocus">      → focuses the form's first text input
//   <input data-controller="autofocus">     → focuses itself
//   <div data-controller="autofocus">       → focuses the tagged field
//     <input data-autofocus-target="field">
//
// Deliberately does nothing on touch-only devices (autofocus there just pops the
// keyboard over the content) or when something already has focus.
const FIELD_SELECTOR = ['input[type="text"]', 'input[type="search"]', "input:not([type])", "textarea"]
  .map((selector) => `${selector}:not([disabled]):not([readonly])`)
  .join(", ")

export default class extends Controller {
  static targets = ["field"]

  connect() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return
    // Never yank the cursor out from under someone — e.g. a Turbo frame that
    // re-renders while they're typing in another field.
    if (document.activeElement && document.activeElement !== document.body) return

    const field = this.#field()
    if (!field || field.offsetParent === null) return

    // preventScroll: Turbo restores scroll position on back/forward, and focusing
    // must not jump the page back to the top of the form.
    field.focus({ preventScroll: true })

    // Land the cursor after any existing value (returning to an already-filtered URL).
    const end = field.value.length
    if (end) field.setSelectionRange(end, end)
  }

  #field() {
    if (this.hasFieldTarget) return this.fieldTarget
    if (this.element.matches(FIELD_SELECTOR)) return this.element
    return this.element.querySelector(FIELD_SELECTOR)
  }
}
